export const overtime_wallet_address = 'AU1ZY6wtsjyN7mxkDCfezsKedVqnxZVoHoyEnFLwhbwJV7P6WvHs';
export const baseAccount_Secret_key = 'S1UZqLGoHZK1Gce5h8akWrEpxBY15a9JwpHLeJrrChRZrQYkAEe';

